import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Licenciamento } from "./licenciamento.model";
import { apiName } from "./data.service";

@Injectable()
export class LicenciamentoApiService {
    private include: any = ['estado'];

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Licenciamento, done: any) {
        return this._restService.onPost(apiName, object, done);
    }

    onPut(object: Licenciamento, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId , done);
    }

    onGetAll(done: any) {
        let filter: any = {include: this.include};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {include: this.include};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetFilter(query: any, done: any) {
        query.include = this.include;
        this._restService.onGetPost(apiName, query, done);
    }

    onGetApiUrl() {
        return apiName;
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/shared/licenciamento-api.service.ts
 **/